import { SVGProps } from "react";

export const AiGradientIconOutline =  (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24" height="24" viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="url(#a)"
      fillRule="evenodd"
      d="M18.333 13.144a12.884 12.884 0 0 1 .927-.235l.209-.044a.5.5 0 0 0 0-1 14.663 14.663 0 0 1-1.138-.276c-2.8-.815-4.275-2.382-5.082-5.113a13.224 13.224 0 0 1-.103-.37l-.084-.331a16.311 16.311 0 0 1-.12-.539.493.493 0 0 0-.473-.371.493.493 0 0 0-.475.376 14.724 14.724 0 0 1-.366 1.45l-.002.006c-.832 2.648-2.348 4.104-5.021 4.888a12.601 12.601 0 0 1-.927.235l-.21.045a.5.5 0 0 0 0 1 14.723 14.723 0 0 1 1.14.275c2.809.813 4.278 2.362 5.082 5.105l.083.299.02.077c.019-.016.06.332.08.317.023.098.046.198.068.3l.009.04.036.174a.493.493 0 0 0 .483.413.493.493 0 0 0 .477-.387 16.114 16.114 0 0 1 .196-.859 12.797 12.797 0 0 1 .17-.593l.002-.005c.832-2.645 2.346-4.094 5.019-4.877Zm-5.864 2.934a7.982 7.982 0 0 1 1.51-2.162 7.922 7.922 0 0 1 2.193-1.55 7.877 7.877 0 0 1-2.246-1.612 8.07 8.07 0 0 1-1.454-2.115 8.007 8.007 0 0 1-1.511 2.168A7.927 7.927 0 0 1 8.77 12.36a7.841 7.841 0 0 1 2.233 1.592 7.99 7.99 0 0 1 1.466 2.127Zm4.293-10.43a.153.153 0 0 0-.153.152h.004c0 .084.062.14.145.156l.023.006.032.007.008.003a3.2 3.2 0 0 1 1.104.508 2.487 2.487 0 0 1 .284.246l.003.002A2.521 2.521 0 0 1 18.872 8a3.274 3.274 0 0 1 .015.076.153.153 0 0 0 .152.154v-.004c.084 0 .14-.062.156-.145l.006-.023.008-.032c0-.002 0-.005.002-.008.113-.432.284-.801.508-1.104a2.479 2.479 0 0 1 .425-.444 2.521 2.521 0 0 1 1.172-.517.15.15 0 0 0 .15-.153c0-.084-.063-.14-.145-.156l-.024-.006-.032-.007-.008-.003a3.197 3.197 0 0 1-1.105-.509 2.5 2.5 0 0 1-.283-.245l-.002-.002a2.36 2.36 0 0 1-.158-.177 2.521 2.521 0 0 1-.517-1.172.153.153 0 0 0-.153-.153v.004c-.084 0-.14.062-.156.144l-.006.024-.007.032-.003.008a3.197 3.197 0 0 1-.508 1.104 2.48 2.48 0 0 1-.246.284l-.002.002a2.362 2.362 0 0 1-.177.158 2.52 2.52 0 0 1-1.115.506 3.248 3.248 0 0 1-.057.011ZM6.848 19.66a2.074 2.074 0 0 1 .93-.478 3.17 3.17 0 0 1 .14-.032.218.218 0 0 0 0-.436 5.028 5.028 0 0 1-.092-.028c-.386-.124-.706-.277-.963-.482a1.9 1.9 0 0 1-.225-.21 2.073 2.073 0 0 1-.47-.921 3.1 3.1 0 0 1-.031-.14.218.218 0 1 0-.436 0 5.43 5.43 0 0 1-.029.092c-.123.386-.277.706-.481.963a1.983 1.983 0 0 1-.21.225 2.07 2.07 0 0 1-.922.47 3.036 3.036 0 0 1-.14.031.218.218 0 0 0 0 .436l.093.03c.385.122.705.276.962.48a2.105 2.105 0 0 1 .217.202l.008.009c.22.241.376.541.47.921a3.1 3.1 0 0 1 .032.14.218.218 0 0 0 .436 0l.028-.093c.124-.385.277-.705.482-.962a1.9 1.9 0 0 1 .201-.217Z"
      clipRule="evenodd"
    />
    <path
      fill="url(#b)"
      d="M9.6 5.613C7.91 5.466 6.98 4.874 6.484 3.7c-.179-.423-.304-.917-.384-1.5 0-.1-.1-.2-.2-.2s-.2.1-.2.2c-.08.583-.205 1.077-.384 1.5C4.821 4.874 3.891 5.466 2.2 5.613c-.1 0-.2.1-.2.2s.1.2.2.2c2.1.4 3.2 1.187 3.5 3.387 0 .1.1.2.2.2s.2-.1.2-.2c.3-2.2 1.4-2.987 3.5-3.387.1 0 .2-.1.2-.2s-.1-.2-.2-.2Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={-7.733}
        x2={11.416}
        y1={11.576}
        y2={31.039}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#03A5AB" />
        <stop offset={1} stopColor="#8B3DFF" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={-7.733}
        x2={11.416}
        y1={11.576}
        y2={31.039}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#03A5AB" />
        <stop offset={1} stopColor="#8B3DFF" />
      </linearGradient>
    </defs>
  </svg>
);


export const AiGradientIconFilled  = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24" height="24" viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="url(#a)"
      d="M12.8 7.484c-2.254-.196-3.495-.985-4.155-2.55-.238-.565-.406-1.224-.512-2a.287.287 0 0 0-.266-.267.287.287 0 0 0-.267.266c-.106.777-.273 1.436-.511 2-.661 1.566-1.901 2.355-4.156 2.55a.287.287 0 0 0-.266.268c0 .133.133.266.266.266C5.733 8.551 7.2 9.6 7.6 12.533c0 .134.133.267.267.267a.287.287 0 0 0 .266-.267C8.533 9.6 10 8.551 12.8 8.017a.287.287 0 0 0 .267-.266.287.287 0 0 0-.267-.267Z"
    />
    <path
      fill="url(#b)"
      d="M25.958 15.82c-5.333-1.067-7.634-3.639-8.701-8.839a.658.658 0 0 0-.632-.495.657.657 0 0 0-.633.502c.01-.02-.012.008 0 0-1.067 5.333-3.5 7.765-8.7 8.832a.667.667 0 0 0 0 1.333c5.333 1.067 7.623 3.584 8.69 8.784.057.31.316.55.643.55a.657.657 0 0 0 .636-.517c.008-.01-.006.013 0 0 1.067-5.333 3.497-7.75 8.697-8.817a.667.667 0 0 0 0-1.333Z"
    />
    <path
      fill="url(#c)"
      d="M28.62 7.733c0-.112-.082-.187-.193-.208l-.073-.018c-1.558-.405-2.502-1.365-2.765-2.81a.204.204 0 0 0-.204-.203v.004c-.112 0-.186.083-.208.193l-.017.074c-.406 1.558-1.366 2.502-2.81 2.765a.204.204 0 0 0-.204.203h.004c0 .113.083.187.193.208l.074.018c1.558.406 2.502 1.365 2.765 2.81 0 .113.091.204.203.204v-.005c.113 0 .187-.082.208-.193l.018-.074c.406-1.557 1.366-2.501 2.81-2.764a.2.2 0 0 0 .2-.204Z"
    />
    <path
      fill="url(#d)"
      d="M10.558 24.954c-1.333-.4-2.11-1.043-2.376-2.376a.29.29 0 0 0-.581 0c-.4 1.333-1.043 2.11-2.376 2.376a.29.29 0 0 0 0 .581c1.333.4 2.11 1.043 2.376 2.376a.29.29 0 0 0 .581 0c.4-1.333 1.043-2.11 2.376-2.376a.29.29 0 0 0 0-.581Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={-10.31}
        x2={15.221}
        y1={15.434}
        y2={41.385}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#03A5AB" />
        <stop offset={1} stopColor="#8B3DFF" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={-10.31}
        x2={15.221}
        y1={15.434}
        y2={41.385}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#03A5AB" />
        <stop offset={1} stopColor="#8B3DFF" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={-10.31}
        x2={15.221}
        y1={15.434}
        y2={41.385}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#03A5AB" />
        <stop offset={1} stopColor="#8B3DFF" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={-10.31}
        x2={15.221}
        y1={15.434}
        y2={41.385}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#03A5AB" />
        <stop offset={1} stopColor="#8B3DFF" />
      </linearGradient>
    </defs>
  </svg>
)